import { render, staticRenderFns } from "./HardSoftConsonantsSchoolPreparingForm.vue?vue&type=template&id=946edfac&scoped=true&lang=pug&"
import script from "./HardSoftConsonantsSchoolPreparingForm.vue?vue&type=script&lang=js&"
export * from "./HardSoftConsonantsSchoolPreparingForm.vue?vue&type=script&lang=js&"
import style0 from "./HardSoftConsonantsSchoolPreparingForm.vue?vue&type=style&index=0&id=946edfac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946edfac",
  null
  
)

export default component.exports